/**
 * PaymentsCarnetController — panneau disclosure « Télécharger le carnet » sur
 * /paiements.html (EPIC-045 / 45.7 — §7.K.F ; refonte 99.54).
 *
 * Le bouton toggle de la barre d'actions déplie/replie un panneau inline qui
 * contient le sélecteur de mois + le bouton de téléchargement. Le `<select>`
 * est hydraté avec les 12 derniers mois (libellés FR) au connect, puis le
 * téléchargement direct de `/v1/payments/carnet-imprimable?month=YYYY-MM`
 * se fait via un `<a download>` programmatique. Le JWT est porté par cookie
 * (credentials include), le navigateur l'envoie naturellement sur le GET
 * déclenché par l'ancre.
 *
 * Aucun HTML inline : les `<option>` sont créées via `document.createElement`
 * ciblé sur `<select>` (équivalent natif, pas de templating string).
 */

import BaseController from "./base_controller.js";

const MONTH_LABELS_FR = [
  "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre",
];

export default class PaymentsCarnetController extends BaseController {
  static targets = ["month", "panel", "toggle"];

  connect() {
    this.populateMonths();
  }

  toggle() {
    if (!this.hasPanelTarget) return;
    if (this.panelTarget.hidden) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    if (!this.hasPanelTarget) return;
    this.panelTarget.hidden = false;
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", "true");
    }
    if (this.hasMonthTarget) this.monthTarget.focus();
  }

  close() {
    if (!this.hasPanelTarget) return;
    this.panelTarget.hidden = true;
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", "false");
    }
  }

  populateMonths() {
    if (!this.hasMonthTarget) return;
    const select = this.monthTarget;
    // Clear options résiduelles éventuelles (re-connect Stimulus en SPA).
    while (select.firstChild) select.removeChild(select.firstChild);

    const now = new Date();
    for (let i = 0; i < 12; i++) {
      const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const opt = document.createElement("option");
      opt.value = `${yyyy}-${mm}`;
      opt.textContent = `${MONTH_LABELS_FR[d.getMonth()]} ${yyyy}`;
      select.appendChild(opt);
    }
  }

  download(event) {
    event.preventDefault();
    if (!this.hasMonthTarget) return;
    const month = this.monthTarget.value;
    if (!month) return;

    const url = `/v1/payments/carnet-imprimable?month=${encodeURIComponent(month)}`;
    const a = document.createElement("a");
    a.href = url;
    a.download = `carnet-paiements-${month}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    this.close();
  }
}
